import {register} from './../exports/theme-sections';
import popoutSection from './../features/popout';

const footerSection = {
  onLoad() {
    // Lighthouse fires security warning for the Shopify link.
    var shopifyLink = document.querySelector('[data-powered-link]');
    if (shopifyLink) {
      shopifyLink.querySelector('a').setAttribute('rel', 'noopener');
    }
  },
};

register('footer', [popoutSection, footerSection]);
